import Cookie from 'js-cookie';

const MIME_TYPE_MAP: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
};

function isAllowedFileType(extension: string): extension is keyof typeof MIME_TYPE_MAP {
  return extension in MIME_TYPE_MAP;
}

export function validateFile(file: File): string | null {
  const extension = file.name.split('.').pop()?.toLowerCase() || '';
  const mimeType = file.type.toLowerCase();

  if (isAllowedFileType(extension)) return MIME_TYPE_MAP[extension];

  const matchingMime = Object.values(MIME_TYPE_MAP).find(allowedMime => allowedMime.toLowerCase() === mimeType);

  return matchingMime ?? null;
}

export function getAcceptAttribute(): string {
  return [...new Set(Object.values(MIME_TYPE_MAP))].join(',');
}

export interface UploadApiNextChatAttachmentProps {
  file: File;
  signal?: AbortSignal;
  subdomain: string;
}

export interface UploadApiNextChatAttachmentResponse {
  data: {
    key: string;
    filename: string;
    mimeType: string;
  };
}

function isValidUploadResponse(data: unknown): data is UploadApiNextChatAttachmentResponse {
  return (
    typeof data === 'object' &&
    data !== null &&
    'data' in data &&
    typeof (data as UploadApiNextChatAttachmentResponse).data === 'object' &&
    (data as UploadApiNextChatAttachmentResponse).data !== null &&
    typeof (data as UploadApiNextChatAttachmentResponse).data.key === 'string'
  );
}

export async function uploadApiNextChatAttachment({ file, subdomain, signal }: UploadApiNextChatAttachmentProps) {
  const formData = new FormData();
  formData.append('file', file);

  return fetch(`/${subdomain}/api-next/v2/chat/upload_attachment`, {
    headers: {
      'X-XSRF-TOKEN': Cookie.get('XSRF-TOKEN') || '',
    },
    body: formData,
    method: 'POST',
    signal,
  }).then(async res => {
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const json: unknown = await res.json();
    if (!isValidUploadResponse(json)) {
      throw new Error('Invalid response format from upload API');
    }
    return json;
  });
}
